// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation--gLngJcXls","logo":"logo--1usaAxlwX","user":"user--SVhlAPkOV","username":"username--2JPWBS4L6"};